import axios, { type AxiosInstance } from 'axios'

// MD5 hash function (simple implementation for throttling)
const simpleHash = (str: string): string => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash = hash & hash
  }
  return hash.toString()
}

// Throttling interceptor
export function setThrottling(axiosInstance: AxiosInstance, time: number) {
  const throttlingTokenCancel = new Map<string, number>()

  axiosInstance.interceptors.request.use(config => {
    const nowTime = new Date().getTime()
    const tokenKey = simpleHash(JSON.stringify(config))
    const lastTime = throttlingTokenCancel.get(tokenKey) ?? 0

    if (nowTime - lastTime < time) {
      return Promise.reject(new Error('请求过于频繁，请稍后再试'))
    } else {
      throttlingTokenCancel.set(tokenKey, nowTime)
    }
    return config
  })

  return axiosInstance
}

// Debounce interceptor
export function setDebounce(axiosInstance: AxiosInstance, time: number) {
  const debounceTokenCancel = new Map<string, () => void>()

  axiosInstance.interceptors.request.use(config => {
    const tokenKey = simpleHash(JSON.stringify(config))
    const cancel = debounceTokenCancel.get(tokenKey)

    if (cancel) {
      cancel()
    }

    return new Promise(resolve => {
      const timer = setTimeout(() => {
        debounceTokenCancel.delete(tokenKey)
        resolve(config)
      }, time)

      debounceTokenCancel.set(tokenKey, () => {
        clearTimeout(timer)
        throw Error('防抖处理中，稍后再试')
      })
    })
  })

  return axiosInstance
}
